var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"inputtext",attrs:{"disabled":_vm.disabled,"rules":_vm.rules,"label":_vm.label},on:{"input":_vm.change}})}
var staticRenderFns = []
export { render, staticRenderFns }